<template>
    <div>
      500
    </div>
</template>
<script>
export default {
    data() {
      return{}
    },
    methods:{}
}
</script>
<style scoped>

</style>